/**
 * WHERE MONEY COMING IN IS WRITTEN DOWN: one door per business, read off its
 * modules and never stored. A business with documents writes its income on a
 * document, and every other business in the Libro. Where sales have a door,
 * the Libro still takes a loose income from whoever also writes expenses.
 * Read by `moneyDoor`, both clients' money doors and the server's POST /ledger.
 */
import { hasModule } from "./modules.js";
/** Where money IN is recorded in this business. */
export function incomeDoor(modules) {
    return hasModule(modules, "pedidos") ? "documents" : "ledger";
}
/**
 * Whether money IN has a door of its own here (the documents). There, the
 * Libro's free income is for whoever also writes expenses -- see
 * `freeIncomeOpens`.
 */
export function hasSalesDoor(modules) {
    return incomeDoor(modules) !== "ledger";
}
/**
 * THE FREE INCOME'S ONE RULE, read by both clients as `moneyDoor`'s `income`
 * and by the server's POST /ledger. Not every income is a sale (a loan, the
 * owner's own money, a supplier's refund), so the Libro takes income in every
 * business; where sales have their own door, only whoever also writes expenses
 * may write a loose one, so «tickets only» cannot bring income in by the side.
 */
export function freeIncomeOpens(writesExpenses, modules) {
    return !hasSalesDoor(modules) || writesExpenses;
}
